import React from 'react';
import { AchievementDefinition, AchievementRarity } from '../types/achievements';

interface AchievementBadgeProps {
  definition: AchievementDefinition;
  unlocked: boolean;
}

const AchievementBadge: React.FC<AchievementBadgeProps> = ({ definition, unlocked }) => {
  return (
    <div
      className={`achievement-badge ${unlocked ? 'achievement-unlocked' : 'achievement-locked'} rarity-${definition.rarity.toLowerCase()}`}
      title={unlocked ? definition.description : '???'}
    >
      <span className="achievement-badge-icon">{unlocked ? definition.icon : '🔒'}</span>
      <span className="achievement-badge-name">{unlocked ? definition.name : '???'}</span>
      <span className={`achievement-badge-rarity rarity-text-${definition.rarity.toLowerCase()}`}>
        {definition.rarity}
      </span>
    </div>
  );
};

export default AchievementBadge;
